import React, { useState } from 'react';
import "../Login.css"
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import {Token, post} from "../../../Script/Session.js";
import { useNavigate } from 'react-router-dom';
import {setCookie, getCookie, cookieExists, deleteCookie} from "../../../Script/cookies.js";
import { getloginvalue } from '../../../Script/variables.js';
const FA = () => {
    const navigate = useNavigate();
    const [aftercontentemail, setAfterContentemail] = useState(false);
    const [afterContentpw, setAfterContentpw] = useState("");
    let elligalchars = false;
    const changeinputtext = () => {
        setAfterContentemail(false);
        let us = document.getElementById("username");
  
        if (us.value.includes(">")||us.value.includes("<") || us.value.includes('"') || us.value.includes("'") || us.value.includes(" ") || us.value.includes(":")){
          elligalchars = true
          us.style.borderColor =  "#ff0000";
 
        }else {
          elligalchars = false
          us.style.borderColor =  "#ccc";
    
        }

        
  
      };
  
      const login = (event) =>{
        event.preventDefault();
        let us = document.getElementById("username");
        let remember = document.getElementById("remember").checked;
        let code = us.value;
        if (elligalchars){
            us.blur();
            return;
        }
        console.log(getloginvalue());
        let body = {};
        body.value = getloginvalue();
        body.remember = remember;
        body.code = code;
        let response = post(body, "/auth2fa");
        if (response == null){
            setAfterContentemail(true);
            us.style.borderColor = "#ff0000";
            return;
        }
        let json = JSON.parse(response);
        let t = "-1";
        try {
          t = json.token
        }catch (e){
          setAfterContentemail(true);
          us.style.borderColor = "#ff0000";
          return 
        }
        if (t == "-1"){
          setAfterContentemail(true);
          us.style.borderColor = "#ff0000";
            return;
        }
        console.log("token is : " + t);
        Token.set(t);
        if (remember){
          setCookie("balk.intranet.value", getloginvalue());
          setCookie("balk.intranetcode", code);
        }else {
          deleteCookie("balk.intranet.value");
          deleteCookie("balk.intranetcode");
        }
        navigate("/home");

        
      }

    return (    
        <div class="arounddev">
            <div class="login-container">
              <div className="email-header">
                 <h1>2Faktor Authentifikation</h1>
              </div>

            

                <form class="login-form" onSubmit={login}>
                <p className="faktorauth-p">Wir haben an ihre Email adresse eine Nachricht mit einem 2Faktor Authentifikations Code Gesendet</p>
                    <label class="login-label" for="username">2Faktor Code</label>
                    <div className={aftercontentemail ? "login-after-div" : "not-aktive-login-after"} id="emailerror" name="emailerror" >
                        <input onChange={changeinputtext} class="login-input" type="text" id="username" name="username" ></input>
                    </div>

                    <div class="remember-me">
                        <input type="checkbox" id="remember" name="remember"></input>
                        <label for="remember">Eingeloggt bleiben</label>
                    </div>



                    <button class="login-button" onClick={login} >
                        Anmelden
                    </button>
                </form>
            </div>
        </div>


  )
}


export default FA;